import { HttpStatusCode } from '@angular/common/http';
import _ from 'lodash';

export enum CustomErrorCode {
  DeviceOffline = 'DEVICE_OFFLINE',
  NoNetwork = 'NO_NETWORK_ERROR',
  UnknownError = 'UNKNOWN_ERROR',
  RequestTimeout = 'REQUEST_TIMEOUT_ERROR',
  HttpNoResponseError = 0
}

export const GENERAL_ERROR_MESSAGE = 'errors.generalServerError';

const ConnectionErrorMessage = 'errors.connectionError';

const CustomErrorMessageByCode: { [key in CustomErrorCode]: string } = {
  [CustomErrorCode.DeviceOffline]: 'errors.deviceOffline',
  [CustomErrorCode.HttpNoResponseError]: ConnectionErrorMessage,
  [CustomErrorCode.RequestTimeout]: ConnectionErrorMessage,
  [CustomErrorCode.NoNetwork]: ConnectionErrorMessage,
  [CustomErrorCode.UnknownError]: 'errors.unknownError'
};

const HttpResponseMessageByCode: { [key: string]: string } = {
  /** Http Client Error */
  [HttpStatusCode.BadRequest]: GENERAL_ERROR_MESSAGE,
  [HttpStatusCode.Unauthorized]: 'errors.unauthorized',
  [HttpStatusCode.Forbidden]: 'errors.forbiddenError',
  [HttpStatusCode.NotFound]: 'errors.notFoundError',
  /** Http Server Error */
  [HttpStatusCode.InternalServerError]: GENERAL_ERROR_MESSAGE,
  [HttpStatusCode.BadGateway]: GENERAL_ERROR_MESSAGE
};

export class ErrorConstant {
  static readonly ErrorMessageByCode = _.merge(
    CustomErrorMessageByCode,
    HttpResponseMessageByCode
  );

  //#region Login

  static readonly LOGIN_PAGE_ERROR_CODE = {
    LP_000001: 'LP_000001'
  };

  static readonly LOGIN_PAGE_ERROR: { [key: string]: string } = {
    LP_000001: 'errors.authenticateApiFailed'
  };

  static readonly EmptyMacroGridsErrorMessage = 'errors.emptyMacroGridsError';

  static readonly CUSTOM_RETRY_ERROR_MSG = {
    GET_MENU_TALLY: 'errors.failedLoadMenu',
    GET_POS_ITEMS_MANAGING: 'errors.failedLoadItems'
  };

  static readonly TICKET_ITEM_REFUND_IN_PROGRESS_STATUS =
    'ticket_item_has_refund_in_progress';

  /**
   * Backend error codes (the `status` field of the pos/v3 error envelope
   * `{ status, error, message }`) that represent a PERMANENT rejection.
   *
   * Retrying these can never succeed - the request is invalid, not unlucky -
   * so they must bypass the retry alert and surface the server's message
   * directly to the operator instead.
   *
   * Note this is deliberately keyed on the error CODE rather than on HTTP 422,
   * because some 422s are genuinely transient and SHOULD be retried - most
   * notably TICKET_ITEM_REFUND_IN_PROGRESS_STATUS, which clears on its own.
   */
  static readonly NON_RETRYABLE_ERROR_STATUSES: readonly string[] = [
    'ticket_cannot_be_deleted'
  ];

  static readonly OPERATOR_NOT_FOUND_STATUS = 'operator_not_found';
  static readonly INSUFFICIENT_PERMISSIONS_STATUS = 'insufficient_permissions';

  static readonly APPLICATION_ERROR_STATUSES = [
    ErrorConstant.OPERATOR_NOT_FOUND_STATUS,
    ErrorConstant.INSUFFICIENT_PERMISSIONS_STATUS
  ];
  //#endregion
}
